import { DetectorType } from "../../utils/enum";
import { clearLog, log } from "../../utils/log";
import { IS } from "../../utils/util";
import { Detector } from "../detector";

export default class extends Detector {

  date: Date = new Date();
  count: number = 0;

  constructor() {
    super({
      type: DetectorType.DateToString,
      enabled: !IS.iosChrome && !IS.iosEdge, // iosChrome 中會有 bug
    });
  }

  init() {
    this.date = new Date();
    this.count = 0;

    this.date.toString = () => {
      this.count++;
      return '';
    };
  }

  detect() {
    this.count = 0;
    log(this.date);
    clearLog();
    if (this.count >= 2) {
      this.onDevToolOpen();
    }
  }
}